export const environment = {
  production: false,
  name: 'LOCAL',
  inMemoryWebApiEnabled: false,
  animateVanMarkers: true,
  loggingOptions: {
    loglevel: 'Debug', // logging levels: All|Debug|Info|Warn|Error|Off
    logToFile: true,
    logToRest: false,
    logToLocalStorage: true,
    debugCategories: {  // toggle individual debug log categories
      auth: false,      // [AuthFlow] MSAL/auth messages
      worker: false,    // worker thread lifecycle messages
      markers: false,   // map marker add/update/remove messages
      http: false,      // PUT/GET/POST response logging
      location: false,  // GPS location logging
      ui: false         // UI state, dialog, form logging
    }
  }
};
